<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0769 3.77917C16.5251 3.06249 15.5606 2.80075 14.722 3.16042L6.22181 6.80576H6C4.34315 6.80576 3 8.16754 3 9.84738V17.9584C3 19.6382 4.34315 21 6 21H18C19.6569 21 21 19.6382 21 17.9584V9.84738C21 8.59955 20.2589 7.52722 19.1985 7.0582L17.1754 3.91884L17.0769 3.77917ZM16.6468 6.80576L15.5011 5.02797L11.3557 6.80576H16.6468ZM19 9.84738C19 9.28743 18.5523 8.83351 18 8.83351H6C5.44772 8.83351 5 9.28743 5 9.84738V17.9584C5 18.5183 5.44772 18.9723 6 18.9723H18C18.5523 18.9723 19 18.5183 19 17.9584V15.4237H16C15.4477 15.4237 15 14.9698 15 14.4098C15 13.8899 15.386 13.4613 15.8834 13.4028L16 13.3959H19V9.84738Z"
      fill="#636363"
    />
  </svg>
</template>
